export default "__VITE_ASSET__CiZs4eLt__"